import {
    Component,
    OnInit,
    Output,
    Input,
    EventEmitter,
    ViewChild,
    ElementRef,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'mapp-searchbox-input',
    templateUrl: './searchbox.component.html',
    styleUrls: ['./searchbox.component.scss'],
    standalone: false,
})
export class SearchboxComponent implements OnInit {
    @ViewChild('inputField') inputField: ElementRef;

    @Output() searchEvent = new EventEmitter<string>();

    @Input() placeholder = 'Search...';

    searchControl = new FormControl('');

    /**
     *
     */
    ngOnInit(): void {
        this.searchControl.valueChanges
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((value) => {
                this.searchEvent.emit(value);
            });
    }

    /**
     *
     */
    clearInput() {
        this.searchControl.setValue('');
    }
}
